class ValidateInput extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.inputValid = true;

    this.addEventListener("input", () => {
      console.log("input");
      if (!this.inputValid) {
        this._validateInput();
      }
    });

    this.addEventListener("focusout", () => {
      console.log("focusout");
      this._validateInput();
    });
  }

  _validateInput() {
    this.inputValid = this.input?.validity.valid;
    console.log("this.inputValid", this.inputValid);
    this.input?.classList.toggle("error", !this.inputValid);
  }

  get input() {
    return this.querySelector("input");
  }
}

if (!customElements.get("validate-input")) {
  customElements.define("validate-input", ValidateInput);
}

// this.form?.addEventListener("submit", (e) => {
//   e.preventDefault();
//   this.addItemToCart();
// });

// this.input?.addEventListener("change", this.onVariantChange);

// this.customValueInput.addEventListener("input", (e) => {
//   if (!this.customValueInputValid) {
//     this.validateCustomValueInput();
//   }
//   this.disableAtcButtons(!this.customValueInput.validity.valid);
//   this.renderProductInfo();
// });

// this.customValueInput.addEventListener("focusout", (e) => {
//   this.validateCustomValueInput();
// });

// this.toggleCustomValueInput();
